import { render } from "./Footer.vue?vue&type=template&id=18b23026&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=18b23026&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/2024-mcdo-gamecenter-wrapper/2024-mcdo-gamecenter-wrapper/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b23026"]])

export default __exports__